module.exports = __webpack_public_path__ + "static/media/illus.bb5e21ed.png";